
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminos-condiciones",
      function () {
        return require("private-next-pages/terminos-condiciones.js");
      }
    ]);
  